import { Typography } from "PFComponents/typography";
import React from "react";

type SubPageHeaderProps = {
  title: string;
};

export const SubPageHeader = ({ title }: SubPageHeaderProps) => (
  <Typography variant="h4" noMargin>
    {title}
  </Typography>
);
